import React from 'react';
import * as styles from './styles/styles.module.scss';

export type Props = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  text: React.ReactNode;
  className?: string;
}

const CommunityStat = ({ title = '', subtitle = '', text = '', className = '' }: Props): JSX.Element => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default CommunityStat;
